/* eslint-disable no-unused-vars, react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { Td, Tr } from "@lightspeed/cirrus-table";
import { Button } from "@lightspeed/flame/Button";
import { Input } from "@lightspeed/flame/Input";
import { Switch } from "@lightspeed/flame/Switch";
import { useDispatch, useSelector } from "react-redux";
import * as databaseActions from "../../../redux/actions/databaseActions";
import D365DimensionsModal from "../D365DimensionsModal";
import QuickBooksClassDepartmentField from "../QuickBooksClassDepartmentField";
import DiscountAccountField from "./DiscountAccountField";
import {
  formatD365DimensionTooltip,
  getD365DimensionMappingValue,
  hasD365DimensionMapping,
} from "../../../utils/d365Dimensions";

let categoryAccountDropdownId = 0;

const Row = ({
  item,
  retail,
  accountsList,
  classList,
  d365DimensionsList = [],
  customersList,
  showHiddenFields,
  isD365Integration = false,
  hideClassDepartmentColumn = false,
}) => {
  const dispatch = useDispatch();
  const ui = useSelector((state) => state.ui);
  const userState = useSelector((state) => state.userState);
  const database = useSelector((state) => state.database);

  const [edit, setEdit] = useState(false);
  const [changed, setChanged] = useState(false);

  const [inputBox1, setInputBox1] = useState("");
  const [inputBox2, setInputBox2] = useState("");
  const [checkBox3, setCheckBox3] = useState(false);
  const [inputBox4, setInputBox4] = useState("");
  const [inputBox5, setInputBox5] = useState("");
  const [inputBox6, setInputBox6] = useState("");
  const [inputBox7, setInputBox7] = useState("");
  const [inputBox8, setInputBox8] = useState("");
  const [inputBox9, setInputBox9] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [mealMappings, setMealMappings] = useState([]);
  const [dimensionMapping, setDimensionMapping] = useState("");

  const [kCogsId, setKCogsId] = useState("");
  const [kCogsName, setKCogsName] = useState("");

  const normalAccount = item.account_id ?? "";
  const normalAccountDescription = item.account_description ?? "";
  const normalDiscountAccount = item.account_id_discount ?? "";
  const normalDiscountDescription = item.account_description_discount ?? "";
  const [discountAccount, setDiscountAccount] = useState(normalDiscountAccount);
  const [discountAccountDescription, setDiscountAccountDescription] = useState(normalDiscountDescription);

  useEffect(() => {
    setDiscountAccount(normalDiscountAccount);
    setDiscountAccountDescription(normalDiscountDescription);
  }, [normalDiscountAccount, normalDiscountDescription]);
  const normalCheck = item.flash === "Yes";
  const normalCogs = item.cogs ?? "";
  const normalCogsDescription = item.cogs_description ?? "";
  const normalCogs2 = item.cogs2 ?? "";
  const normalCogsDescription2 = item.cogs_description2 ?? "";
  const normalCogsK = item.cogs_id ?? "";
  const normalCogsDescriptionK = item.cogs_name ?? "";
  const normalClassDeptLoc = item.class_department_location ?? "";
  const normalCustomer = item.qb_customer_id ?? "";
  const normalDimensionMapping = getD365DimensionMappingValue(item);
  const mealPeriodSettings = ui.settings || {};
  const activeMealPeriods =
    database.currentCompany.type === "RESTOK" &&
    mealPeriodSettings.meal_period_enabled === "on"
      ? [1, 2, 3, 4]
          .map((index) => ({
            index,
            label: String(mealPeriodSettings[`meal_period_${index}_name`] || "").trim(),
          }))
          .filter((period) => period.label !== "")
      : [];
  const isMealPeriodMode = activeMealPeriods.length > 0;

  const parseMaybeJson = (value) => {
    if (!value) return null;
    if (typeof value === "object") return value;

    try {
      return JSON.parse(value);
    } catch (err) {
      return null;
    }
  };

  const getExistingMealMapping = (period) => {
    const rawMappings = parseMaybeJson(
      item?.meal_period_mapping || item?.meal_period_mappings || item?.meal_periods
    );
    const mappingList = Array.isArray(rawMappings)
      ? rawMappings
      : Array.isArray(rawMappings?.mappings)
      ? rawMappings.mappings
      : [];

    return (
      mappingList.find(
        (mapping) =>
          Number(
            mapping.key ??
              mapping.meal_period_key ??
              mapping.index ??
              mapping.meal_period_index ??
              mapping.period_index
          ) === period.index ||
          mapping.name === period.label ||
          mapping.meal_period_name === period.label
      ) || {}
    );
  };

  const buildMealMappings = () =>
    activeMealPeriods.map((period) => {
      const existing = getExistingMealMapping(period);
      const prefix = `meal_period_${period.index}`;

      return {
        key: period.index,
        mealPeriodKey: period.index,
        rowKey: `${item.company_id}-${item.category_id}-${period.index}`,
        index: period.index,
        name: period.label,
        accountId:
          existing.account_id ??
          existing.accountId ??
          item?.[`${prefix}_account_id`] ??
          normalAccount,
        accountDescription:
          existing.account_description ??
          existing.accountDescription ??
          item?.[`${prefix}_account_description`] ??
          normalAccountDescription,
        classDepartmentLocation:
          existing.class_department_location ??
          existing.classDepartmentLocation ??
          item?.[`${prefix}_class_department_location`] ??
          normalClassDeptLoc,
        customerId:
          existing.qb_customer_id ??
          existing.customer_id ??
          existing.customerId ??
          item?.[`${prefix}_qb_customer_id`] ??
          normalCustomer,
        cogs:
          existing.cogs ?? existing.cogs_id ?? item?.[`${prefix}_cogs`] ?? normalCogs,
        cogsDescription:
          existing.cogs_description ??
          existing.cogs_name ??
          item?.[`${prefix}_cogs_description`] ??
          normalCogsDescription,
        cogs2:
          existing.cogs2 ?? item?.[`${prefix}_cogs2`] ?? normalCogs2,
        cogsDescription2:
          existing.cogs_description2 ??
          existing.cogs_name2 ??
          item?.[`${prefix}_cogs_description2`] ??
          normalCogsDescription2,
      };
    });

  const hasParentPos =
    database.currentCompany.type === "RETAIL" ||
    (item.parentid ?? "") !== "";

  const [showDropdownAcc, setShowDropdownAcc] = useState(false);
  const accountDropdownOwnerRef = useRef(null);
  if (!accountDropdownOwnerRef.current) {
    categoryAccountDropdownId += 1;
    accountDropdownOwnerRef.current = `category-account-${categoryAccountDropdownId}`;
  }
  const [searchTextAcc, setSearchTextAcc] = useState("");

  const [showClassDropdown8, setShowClassDropdown8] = useState(false);
  const [classSearchText8, setClassSearchText8] = useState("");

  const [showCustomerDropdown, setShowCustomerDropdown] = useState(false);
  const [customerSearchText, setCustomerSearchText] = useState("");
  const [d365Modal, setD365Modal] = useState(null);

  const [showDropdownCogs, setShowDropdownCogs] = useState(false);
  const [searchTextCogs, setSearchTextCogs] = useState("");

  const [showDropdownCogsTotal, setShowDropdownCogsTotal] = useState(false);
  const [searchTextCogsTotal, setSearchTextCogsTotal] = useState("");

  const accSearchRef = useRef(null);
  const classSearchRef = useRef(null);
  const customerSearchRef = useRef(null);
  const cogsSearchRef = useRef(null);
  const cogsTotalSearchRef = useRef(null);

  useEffect(() => {
    if (showDropdownAcc) accSearchRef.current?.focus();
  }, [showDropdownAcc]);

  useEffect(() => {
    if (!showDropdownAcc || typeof document === "undefined") return;

    const handleOutsideClick = (event) => {
      const dropdownOwner = event.target.closest(
        "[data-account-dropdown-owner]"
      );

      if (
        dropdownOwner?.getAttribute("data-account-dropdown-owner") !==
        accountDropdownOwnerRef.current
      ) {
        setShowDropdownAcc(false);
        setSearchTextAcc("");
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);
    return () => document.removeEventListener("mousedown", handleOutsideClick);
  }, [showDropdownAcc]);

  useEffect(() => {
    if (showClassDropdown8) classSearchRef.current?.focus();
  }, [showClassDropdown8]);

  useEffect(() => {
    if (showCustomerDropdown) customerSearchRef.current?.focus();
  }, [showCustomerDropdown]);

  useEffect(() => {
    if (showDropdownCogs) cogsSearchRef.current?.focus();
  }, [showDropdownCogs]);

  useEffect(() => {
    if (showDropdownCogsTotal) cogsTotalSearchRef.current?.focus();
  }, [showDropdownCogsTotal]);

  useEffect(() => {
    setInputBox1(normalAccount);
    setInputBox2(normalAccountDescription);
    setCheckBox3(normalCheck);
    setInputBox4(normalCogs);
    setInputBox5(normalCogsDescription);
    setInputBox6(normalCogs2);
    setInputBox7(normalCogsDescription2);
    setInputBox8(normalClassDeptLoc);
    setInputBox9(normalCustomer);
    setCustomerId(item.customer_id ? String(item.customer_id) : "");
    setKCogsId(normalCogsK);
    setKCogsName(normalCogsDescriptionK);
    setMealMappings(buildMealMappings());
    setDimensionMapping(normalDimensionMapping);

    setEdit(false);
  }, [
    normalAccount,
    normalAccountDescription,
    normalCheck,
    normalCogs,
    normalCogsDescription,
    normalCogs2,
    normalCogsDescription2,
    normalClassDeptLoc,
    normalCustomer,
    normalCogsK,
    normalCogsDescriptionK,
    item.customer_id,
    item.meal_period_mapping,
    item.meal_period_mappings,
    item.meal_periods,
    mealPeriodSettings.meal_period_enabled,
    mealPeriodSettings.meal_period_1_name,
    mealPeriodSettings.meal_period_2_name,
    mealPeriodSettings.meal_period_3_name,
    mealPeriodSettings.meal_period_4_name,
  ]);

  useEffect(() => {
    const noChanges =
      normalDiscountAccount === discountAccount &&
      normalDiscountDescription === discountAccountDescription &&
      normalAccount === inputBox1 &&
      normalAccountDescription === inputBox2 &&
      normalCheck === checkBox3 &&
      normalCogs === inputBox4 &&
      normalCogsDescription === inputBox5 &&
      normalCogs2 === inputBox6 &&
      normalCogsDescription2 === inputBox7 &&
      normalClassDeptLoc === inputBox8 &&
      normalCustomer === inputBox9;

    const initialMealMappings = buildMealMappings();
    const mealChanges =
      isMealPeriodMode &&
      JSON.stringify(mealMappings) !== JSON.stringify(initialMealMappings);
    const dimensionChanges =
      isD365Integration && normalDimensionMapping !== dimensionMapping;

    setChanged(!noChanges || mealChanges || dimensionChanges);
  }, [
    discountAccount,
    discountAccountDescription,
    normalDiscountAccount,
    normalDiscountDescription,
    inputBox1,
    inputBox2,
    checkBox3,
    inputBox4,
    inputBox5,
    inputBox6,
    inputBox7,
    inputBox8,
    inputBox9,
    normalAccount,
    normalAccountDescription,
    normalCheck,
    normalCogs,
    normalCogsDescription,
    normalCogs2,
    normalCogsDescription2,
    normalClassDeptLoc,
    normalCustomer,
    normalDimensionMapping,
    dimensionMapping,
    isMealPeriodMode,
    mealMappings,
    mealPeriodSettings.meal_period_enabled,
    mealPeriodSettings.meal_period_1_name,
    mealPeriodSettings.meal_period_2_name,
    mealPeriodSettings.meal_period_3_name,
    mealPeriodSettings.meal_period_4_name,
  ]);

  const updateMealMapping = (periodIndex, changes) => {
    setMealMappings((prev) =>
      prev.map((mapping) =>
        mapping.index === periodIndex ? { ...mapping, ...changes } : mapping
      )
    );
    setChanged(true);
  };

  const getMealMappingsPayload = () =>
    mealMappings.map((mapping) => ({
      key: mapping.mealPeriodKey,
      meal_period_key: mapping.mealPeriodKey,
      meal_period_index: mapping.index,
      meal_period_name: mapping.name,
      account_id: mapping.accountId,
      account_description: mapping.accountDescription,
      class_department_location: mapping.classDepartmentLocation,
      qb_customer_id: mapping.customerId,
      customer_id: mapping.customerId,
      cogs: mapping.cogs,
      cogs_description: mapping.cogsDescription,
      cogs2: mapping.cogs2,
      cogs_description2: mapping.cogsDescription2,
    }));

  const handleUpdate = (dimensionMappingOverride) => {
    const discountMapping = {
      token_account_id_discount: discountAccount,
      token_account_name_discount: discountAccountDescription,
    };
    const d365DimensionsValue =
      typeof dimensionMappingOverride === "string"
        ? dimensionMappingOverride
        : currentDimensionMapping || "";
    const primaryMealMapping = isMealPeriodMode
      ? mealMappings.find((mapping) => mapping.index === 1)
      : null;
    const categoryAccountId = primaryMealMapping?.accountId ?? inputBox1;
    const categoryAccountName = primaryMealMapping?.accountDescription ?? inputBox2;
    const categoryClass = primaryMealMapping?.classDepartmentLocation ?? inputBox8;
    const categoryCustomer = primaryMealMapping?.customerId ?? inputBox9;
    const categoryCogs = primaryMealMapping?.cogs ?? inputBox4;
    const categoryCogsName = primaryMealMapping?.cogsDescription ?? inputBox5;
    const categoryCogs2 = primaryMealMapping?.cogs2 ?? inputBox6;
    const categoryCogsName2 = primaryMealMapping?.cogsDescription2 ?? inputBox7;
    const qbCustomerValue = (inputBox9 ?? "").toString().trim() || null;
    const internalCustomerId = (customerId ?? "").toString().trim() || null;

    if (database.currentCompany.type === "RETAIL") {
      dispatch(
        databaseActions.updateRetailCategory(
          userState.user.user_id,
          item.company_id,
          database.currentShop.shop_id,
          inputBox1,
          inputBox2,
          item.category_id,
          checkBox3 ? "Yes" : "",
          inputBox4,
          inputBox5,
          inputBox6,
          inputBox7,
          inputBox8,
          qbCustomerValue,
          internalCustomerId,
          null,
          null,
          d365DimensionsValue,
          databaseActions.getShopCategories(
            database.currentCompany.id,
            userState.user.user_id,
            database.currentShop.shop_id
          ),
          discountMapping
        )
      );
    }

    if (database.currentCompany.type === "RETAILX") {
      dispatch(
        databaseActions.updateRetailCategoryX(
          userState.user.user_id,
          item.company_id,
          database.currentShop.shop_id,
          inputBox1,
          inputBox2,
          item.category_id,
          checkBox3 ? "Yes" : "",
          inputBox4,
          inputBox5,
          inputBox6,
          inputBox7,
          inputBox8,
          qbCustomerValue,
          internalCustomerId,
          null,
          null,
          databaseActions.getShopCategoriesX(
            database.currentCompany.id,
            userState.user.user_id,
            database.currentShop.shop_id
          ),
          discountMapping
        )
      );
    }

    if (database.currentCompany.type === "RESTOK") {
      if (database.currentCompany.direct) {
        dispatch(
          databaseActions.updateRestoCategoriesK(
            userState.user.user_id,
            item.company_id,
            item.category_id,
            categoryAccountId,
            categoryAccountName,
            0,
            categoryCogs,
            categoryCogsName,
            categoryCogs2,
            categoryCogsName2,
            categoryClass,
            (categoryCustomer ?? "").toString().trim() || null,
            (categoryCustomer ?? "").toString().trim() || null,
            isMealPeriodMode ? getMealMappingsPayload() : null,
            d365DimensionsValue,
            databaseActions.patchCurrentAreaCategory(item.category_id, {
              account_id_discount: discountAccount,
              account_description_discount: discountAccountDescription,
              account_id: categoryAccountId,
              account_description: categoryAccountName,
              cogs: categoryCogs,
              cogs_description: categoryCogsName,
              cogs_id: categoryCogs,
              cogs_name: categoryCogsName,
              cogs2: categoryCogs2,
              cogs_description2: categoryCogsName2,
              cogs_name2: categoryCogsName2,
              class_department_location: categoryClass,
              qb_customer_id: (categoryCustomer ?? "").toString().trim() || null,
              customer_id: (categoryCustomer ?? "").toString().trim() || null,
              meal_period_mapping: isMealPeriodMode ? getMealMappingsPayload() : item.meal_period_mapping,
              meal_period_mappings: isMealPeriodMode ? getMealMappingsPayload() : item.meal_period_mappings,
              meal_periods: isMealPeriodMode ? getMealMappingsPayload() : item.meal_periods,
              d365_dimensions: d365DimensionsValue,
            }),
            discountMapping
          )
        );
      } else {
        dispatch(
          databaseActions.updateRestoCategoriesK(
            userState.user.user_id,
            item.company_id,
            item.category_id,
            categoryAccountId,
            categoryAccountName,
            database.currentShop.area_id,
            categoryCogs,
            categoryCogsName,
            categoryCogs2,
            categoryCogsName2,
            categoryClass,
            (categoryCustomer ?? "").toString().trim() || null,
            (categoryCustomer ?? "").toString().trim() || null,
            isMealPeriodMode ? getMealMappingsPayload() : null,
            d365DimensionsValue,
            databaseActions.patchCurrentAreaCategory(item.category_id, {
              account_id_discount: discountAccount,
              account_description_discount: discountAccountDescription,
              account_id: categoryAccountId,
              account_description: categoryAccountName,
              cogs: categoryCogs,
              cogs_description: categoryCogsName,
              cogs_id: categoryCogs,
              cogs_name: categoryCogsName,
              cogs2: categoryCogs2,
              cogs_description2: categoryCogsName2,
              cogs_name2: categoryCogsName2,
              class_department_location: categoryClass,
              qb_customer_id: (categoryCustomer ?? "").toString().trim() || null,
              customer_id: (categoryCustomer ?? "").toString().trim() || null,
              meal_period_mapping: isMealPeriodMode ? getMealMappingsPayload() : item.meal_period_mapping,
              meal_period_mappings: isMealPeriodMode ? getMealMappingsPayload() : item.meal_period_mappings,
              meal_periods: isMealPeriodMode ? getMealMappingsPayload() : item.meal_periods,
              d365_dimensions: d365DimensionsValue,
            }),
            discountMapping
          )
        );
      }
    } else if (database.currentCompany.type === "RESTO") {
      if (database.currentCompany.direct) {
        dispatch(
          databaseActions.updateRestoCategories(
            userState.user.user_id,
            item.company_id,
            item.category_id,
            inputBox1,
            inputBox2,
            0,
            inputBox8,
            qbCustomerValue,
            internalCustomerId,
            0,
            databaseActions.getAreaCategories(
              userState.user.user_id,
              database.currentCompany.id,
              0
            )
          )
        );
      } else {
        dispatch(
          databaseActions.updateRestoCategories(
            userState.user.user_id,
            item.company_id,
            item.category_id,
            inputBox1,
            inputBox2,
            database.currentShop.area_id,
            inputBox8,
            qbCustomerValue,
            internalCustomerId,
            0,
            databaseActions.getAreaCategories(
              userState.user.user_id,
              database.currentCompany.id,
              database.currentShop.area_id
            )
          )
        );
      }
    }

    setEdit(false);
  };

  const renderDiscountCells = () => (
    <>
      <Td width="10%" className="td-acc">
        {!edit ? discountAccount : (
          <DiscountAccountField
            value={discountAccount}
            accountsList={accountsList}
            onChange={setDiscountAccount}
            onSelect={(id, description) => {
              setDiscountAccount(id);
              setDiscountAccountDescription(description);
            }}
            onEnter={handleUpdate}
          />
        )}
      </Td>
      <Td width="16%" className="td-acc">
        {!edit ? discountAccountDescription : (
          <Input
            size="small"
            aria-label="Account Description (Discount)"
            value={discountAccountDescription}
            onChange={(event) => setDiscountAccountDescription(event.target.value)}
            onKeyDown={(event) => event.key === "Enter" && handleUpdate()}
          />
        )}
      </Td>
    </>
  );

  const filterBy = (list, term) => {
    const t = (term || "").toLowerCase();
    return (list || []).filter((x) => {
      const id = (x?.id ?? "").toString().toLowerCase();
      const desc = (x?.description ?? "").toString().toLowerCase();
      return id.includes(t) || desc.includes(t);
    });
  };

  const filteredAccountsAcc = filterBy(accountsList, searchTextAcc);
  const filteredClasses8 = (Array.isArray(classList) ? classList : classList?.classes || []).filter((cls) => {
    const id = (cls?.id ?? "").toString().toLowerCase();
    const desc = (cls?.description ?? "").toString().toLowerCase();
    const s = (classSearchText8 || "").toLowerCase();
    return id.includes(s) || desc.includes(s);
  });
  const d365DimensionRows = isD365Integration
    ? (d365DimensionsList || []).filter((cls) => cls.dimension_level)
    : [];
  const currentDimensionMapping = dimensionMapping || normalDimensionMapping;
  const settingsButtonStyle = {
    marginLeft: 6,
    border: "1px solid #cbd5e1",
    borderRadius: 6,
    background: "#fff",
    color: "#0f172a",
    cursor: "pointer",
    fontSize: 12,
    padding: "3px 6px",
  };
  const renderD365SettingsButton = (target) =>
    isD365Integration ? (
      <button
        type="button"
        style={settingsButtonStyle}
        title={formatD365DimensionTooltip(currentDimensionMapping) || "No dimensions mapped"}
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          setD365Modal(target);
        }}
      >
        {hasD365DimensionMapping(currentDimensionMapping) ? "Dimensions*" : "Dimensions"}
      </button>
    ) : null;
  const applyD365DimensionValue = (nextValue) => {
    if (d365Modal && typeof d365Modal === "object") {
      updateMealMapping(d365Modal.index, { classDepartmentLocation: nextValue });
    } else {
      handleUpdate(nextValue);
    }
  };
  const d365ModalElement = (
    <D365DimensionsModal
      open={!!d365Modal}
      value={currentDimensionMapping}
      dimensions={d365DimensionRows}
      onClose={() => setD365Modal(null)}
      onApply={applyD365DimensionValue}
    />
  );
  const filteredCustomers = filterBy(customersList, customerSearchText);
  const filteredAccountsCogs = filterBy(accountsList, searchTextCogs);
  const filteredAccountsCogsTotal = filterBy(accountsList, searchTextCogsTotal);

  if (isMealPeriodMode) {
    const rows = mealMappings.length > 0 ? mealMappings : buildMealMappings();

    if (!edit) {
      return (
        <>
          {d365ModalElement}
          {rows.map((mapping, index) => (
            <Tr
              key={`${mapping.rowKey}-${database.currentShop?.area_id ?? 0}`}
              textAlign="right"
              className={`${ui.theme === "flame" ? "" : "dark-table-row"}`}
              onDoubleClick={() => setEdit(true)}
            >
              {index === 0 && (
                <>
                  <Td width="10%" className="td-pos" rowSpan={rows.length}>
                    {item.company_id}
                  </Td>
                  <Td width="10%" className="td-pos" rowSpan={rows.length}>
                    {item.category_id}
                  </Td>
                  <Td
                    width="20%"
                    className={hasParentPos ? "td-pos" : "td-pos td-pos-last"}
                    rowSpan={rows.length}
                  >
                    {item.category_name}
                  </Td>
                  {hasParentPos && (
                    <Td width="8%" className="td-pos td-pos-last" rowSpan={rows.length}>
                      {item.parentid}
                    </Td>
                  )}
                </>
              )}

              <Td width="10%" className="td-acc td-acc-first">
                <div style={{ display: "grid", gridTemplateColumns: "12ch 1fr", alignItems: "center" }}>
                  <strong title={mapping.name} style={{ display: "block", maxWidth: "12ch", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {mapping.name}
                  </strong>
                  <span>{mapping.accountId}</span>
                </div>
              </Td>
              <Td width="16%" className="td-acc">{mapping.accountDescription}</Td>
              <Td width="10%" className="td-acc" style={{ display: hideClassDepartmentColumn ? "none" : undefined }}>
                {mapping.classDepartmentLocation}
                {index === 0 && renderD365SettingsButton("main")}
              </Td>
              <Td width="10%" className="td-acc">{mapping.customerId}</Td>

              {showHiddenFields && (
                <>
                  {renderDiscountCells()}
                  <Td width="6%" className="td-acc">{index === 0 ? (checkBox3 ? "Yes" : "") : ""}</Td>
                  <Td width="10%" className="td-acc">{mapping.cogs}</Td>
                  <Td width="12%" className="td-acc">{mapping.cogsDescription}</Td>
                  <Td width="10%" className="td-acc">{mapping.cogs2}</Td>
                  <Td width="12%" className="td-acc">{mapping.cogsDescription2}</Td>
                </>
              )}

              {index === 0 && (
                <Td width="8%" textAlign="right" className="td-acc" rowSpan={rows.length}>
                  <Button size="small" fill="true" onClick={() => setEdit(true)}>
                    Edit
                  </Button>
                </Td>
              )}
            </Tr>
          ))}
        </>
      );
    }

    return (
      <>
        {d365ModalElement}
        {rows.map((mapping, index) => (
          <Tr
            key={`${mapping.rowKey}-${database.currentShop?.area_id ?? 0}`}
            textAlign="right"
            className={`${ui.theme === "flame" ? "" : "dark-table-row"}`}
            onDoubleClick={() => setEdit(true)}
          >
            {index === 0 && (
              <>
                <Td width="10%" className="td-pos" rowSpan={rows.length}>
                  {item.company_id}
                </Td>

                <Td width="10%" className="td-pos" rowSpan={rows.length}>
                  {item.category_id}
                </Td>

                <Td
                  width="20%"
                  className={hasParentPos ? "td-pos" : "td-pos td-pos-last"}
                  rowSpan={rows.length}
                >
                  {item.category_name}
                </Td>

                {hasParentPos && (
                  <Td width="8%" className="td-pos td-pos-last" rowSpan={rows.length}>
                    {item.parentid}
                  </Td>
                )}
              </>
            )}

            <Td
              width="10%"
              className="td-acc td-acc-first"
              style={{ position: "relative" }}
            >
              <div
                data-account-dropdown-owner={accountDropdownOwnerRef.current}
                style={{ position: "relative", display: "grid", gridTemplateColumns: "12ch 1fr 14px", alignItems: "center" }}
              >
                <strong title={mapping.name} style={{ display: "block", maxWidth: "12ch", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {mapping.name}
                </strong>
                <Input
                  className="input-wrapper-row-inputbox"
                  type="text"
                  size="small"
                  value={mapping.accountId}
                  onChange={(e) =>
                    updateMealMapping(mapping.index, { accountId: e.target.value })
                  }
                  onKeyDown={(e) => e.key === "Enter" && handleUpdate()}
                />
                <span
                  style={{
                    marginLeft: 4,
                    display: "inline-block",
                    cursor: "pointer",
                    fontSize: 0,
                    width: 0,
                    height: 0,
                    borderLeft: "4px solid transparent",
                    borderRight: "4px solid transparent",
                    borderTop: "5px solid #334155",
                    userSelect: "none",
                  }}
                  onClick={() => {
                    setShowDropdownAcc((prev) =>
                      prev === `meal-acc-${mapping.index}` ? false : `meal-acc-${mapping.index}`
                    );
                    setSearchTextAcc("");
                  }}
                />

                {showDropdownAcc === `meal-acc-${mapping.index}` && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      background: "#fff",
                      zIndex: 1000,
                      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                      border: "1px solid #ccc",
                      borderRadius: 4,
                      width: 450,
                      minWidth: "100%",
                      maxHeight: 200,
                      overflowY: "auto",
                      marginTop: 4,
                    }}
                  >
                    <div style={{ padding: 4 }}>
                      <input
                        ref={accSearchRef}
                        type="text"
                        placeholder="Search..."
                        value={searchTextAcc}
                        onChange={(e) => setSearchTextAcc(e.target.value)}
                        style={{
                          width: "100%",
                          padding: 6,
                          fontSize: 14,
                          border: "1px solid #ccc",
                          borderRadius: 4,
                        }}
                      />
                    </div>

                    {filteredAccountsAcc.map((acc) => (
                      <div
                        key={`${mapping.index}-${acc.id}`}
                        style={{
                          padding: "6px 8px",
                          cursor: "pointer",
                          borderBottom: "1px solid #eee",
                        }}
                        onClick={() => {
                          updateMealMapping(mapping.index, {
                            accountId: acc.id,
                            accountDescription: acc.description,
                          });
                          setShowDropdownAcc(false);
                          setSearchTextAcc("");
                        }}
                      >
                        <strong>{acc.id}</strong> - {acc.description}
                      </div>
                    ))}

                    {filteredAccountsAcc.length === 0 && (
                      <div style={{ padding: "6px 8px", color: "#999" }}>No results</div>
                    )}
                  </div>
                )}
              </div>
            </Td>

            <Td width="16%" className="td-acc">
              <Input
                className="input-wrapper-row-inputbox"
                type="text"
                size="small"
                value={mapping.accountDescription}
                onChange={(e) =>
                  updateMealMapping(mapping.index, { accountDescription: e.target.value })
                }
                onKeyDown={(e) => e.key === "Enter" && handleUpdate()}
              />
            </Td>

            <Td width="10%" className="td-acc" style={{ position: "relative", display: hideClassDepartmentColumn ? "none" : undefined }}>
              <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                <Input
                  className="input-wrapper-row-inputbox"
                  type="text"
                  size="small"
                  value={mapping.classDepartmentLocation}
                  onChange={(e) =>
                    updateMealMapping(mapping.index, {
                      classDepartmentLocation: e.target.value,
                    })
                  }
                  onKeyDown={(e) => e.key === "Enter" && handleUpdate()}
                />
                {index === 0 && renderD365SettingsButton("main")}
                <span
                  style={{
                    marginLeft: 4,
                    display: "inline-block",
                    cursor: "pointer",
                    fontSize: 0,
                    width: 0,
                    height: 0,
                    borderLeft: "4px solid transparent",
                    borderRight: "4px solid transparent",
                    borderTop: "5px solid #334155",
                    userSelect: "none",
                  }}
                  onClick={() => {
                    setShowClassDropdown8((prev) =>
                      prev === `meal-class-${mapping.index}` ? false : `meal-class-${mapping.index}`
                    );
                    setClassSearchText8("");
                  }}
                />

                {showClassDropdown8 === `meal-class-${mapping.index}` && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      background: "#fff",
                      zIndex: 1000,
                      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                      border: "1px solid #ccc",
                      borderRadius: 4,
                      width: 450,
                      minWidth: "100%",
                      maxHeight: 200,
                      overflowY: "auto",
                      marginTop: 4,
                    }}
                  >
                    <div style={{ padding: 4 }}>
                      <input
                        ref={classSearchRef}
                        type="text"
                        placeholder="Search..."
                        value={classSearchText8}
                        onChange={(e) => setClassSearchText8(e.target.value)}
                        style={{
                          width: "100%",
                          padding: 6,
                          fontSize: 14,
                          border: "1px solid #ccc",
                          borderRadius: 4,
                        }}
                      />
                    </div>

                    {filteredClasses8.map((cls) => (
                      <div
                        key={`${mapping.index}-${cls.id}`}
                        style={{
                          padding: "6px 8px",
                          cursor: "pointer",
                          borderBottom: "1px solid #eee",
                        }}
                        onClick={() => {
                          updateMealMapping(mapping.index, {
                            classDepartmentLocation: cls.description,
                          });
                          setShowClassDropdown8(false);
                          setClassSearchText8("");
                        }}
                      >
                        <strong>{cls.id}</strong> - {cls.description}
                      </div>
                    ))}

                    {filteredClasses8.length === 0 && (
                      <div style={{ padding: "6px 8px", color: "#999" }}>No results</div>
                    )}
                  </div>
                )}
              </div>
            </Td>

            <Td width="10%" className="td-acc" style={{ position: "relative" }}>
              <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                <Input
                  className="input-wrapper-row-inputbox"
                  type="text"
                  size="small"
                  value={mapping.customerId}
                  onChange={(e) =>
                    updateMealMapping(mapping.index, { customerId: e.target.value })
                  }
                  onKeyDown={(e) => e.key === "Enter" && handleUpdate()}
                />
                <span
                  style={{
                    marginLeft: 4,
                    display: "inline-block",
                    cursor: "pointer",
                    fontSize: 0,
                    width: 0,
                    height: 0,
                    borderLeft: "4px solid transparent",
                    borderRight: "4px solid transparent",
                    borderTop: "5px solid #334155",
                    userSelect: "none",
                  }}
                  onClick={() => {
                    setShowCustomerDropdown((prev) =>
                      prev === `meal-customer-${mapping.index}` ? false : `meal-customer-${mapping.index}`
                    );
                    setCustomerSearchText("");
                  }}
                />

                {showCustomerDropdown === `meal-customer-${mapping.index}` && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      background: "#fff",
                      zIndex: 1000,
                      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                      border: "1px solid #ccc",
                      borderRadius: 4,
                      width: 450,
                      minWidth: "100%",
                      maxHeight: 200,
                      overflowY: "auto",
                      marginTop: 4,
                    }}
                  >
                    <div style={{ padding: 4 }}>
                      <input
                        ref={customerSearchRef}
                        type="text"
                        placeholder="Search..."
                        value={customerSearchText}
                        onChange={(e) => setCustomerSearchText(e.target.value)}
                        style={{
                          width: "100%",
                          padding: 6,
                          fontSize: 14,
                          border: "1px solid #ccc",
                          borderRadius: 4,
                        }}
                      />
                    </div>

                    {filteredCustomers.map((c) => (
                      <div
                        key={`${mapping.index}-${c.id}`}
                        style={{
                          padding: "6px 8px",
                          cursor: "pointer",
                          borderBottom: "1px solid #eee",
                        }}
                        onClick={() => {
                          updateMealMapping(mapping.index, {
                            customerId: String(c.id),
                          });
                          setShowCustomerDropdown(false);
                          setCustomerSearchText("");
                        }}
                      >
                        <strong>{c.id}</strong> - {c.description}
                      </div>
                    ))}

                    {filteredCustomers.length === 0 && (
                      <div style={{ padding: "6px 8px", color: "#999" }}>No results</div>
                    )}
                  </div>
                )}
              </div>
            </Td>

            {showHiddenFields && (
              <>
                {renderDiscountCells()}
                <Td width="6%" className="td-acc">
                  {index === 0 && (
                    <Switch
                      checked={checkBox3}
                      onChange={() => {
                        setCheckBox3((prev) => !prev);
                        setChanged(true);
                      }}
                    />
                  )}
                </Td>

                <Td width="10%" className="td-acc">
                  <Input
                    size="small"
                    value={mapping.cogs}
                    onChange={(e) =>
                      updateMealMapping(mapping.index, { cogs: e.target.value })
                    }
                    onKeyDown={(e) => e.key === "Enter" && handleUpdate()}
                  />
                </Td>

                <Td width="12%" className="td-acc">
                  <Input
                    size="small"
                    value={mapping.cogsDescription}
                    onChange={(e) =>
                      updateMealMapping(mapping.index, { cogsDescription: e.target.value })
                    }
                    onKeyDown={(e) => e.key === "Enter" && handleUpdate()}
                  />
                </Td>

                <Td width="10%" className="td-acc">
                  <Input
                    size="small"
                    value={mapping.cogs2}
                    onChange={(e) =>
                      updateMealMapping(mapping.index, { cogs2: e.target.value })
                    }
                    onKeyDown={(e) => e.key === "Enter" && handleUpdate()}
                  />
                </Td>

                <Td width="12%" className="td-acc">
                  <Input
                    size="small"
                    value={mapping.cogsDescription2}
                    onChange={(e) =>
                      updateMealMapping(mapping.index, { cogsDescription2: e.target.value })
                    }
                    onKeyDown={(e) => e.key === "Enter" && handleUpdate()}
                  />
                </Td>
              </>
            )}

            {index === 0 && (
              <Td width="8%" textAlign="right" className="td-acc" rowSpan={rows.length}>
                {!edit ? (
                  <Button size="small" fill="true" onClick={() => setEdit(true)}>
                    Edit
                  </Button>
                ) : (
                  <Button size="small" fill="true" onClick={handleUpdate} disabled={!changed}>
                    Update
                  </Button>
                )}
              </Td>
            )}
          </Tr>
        ))}
      </>
    );
  }

  return (
    <>
    {d365ModalElement}
    <Tr
      textAlign="right"
      className={`${ui.theme === "flame" ? "" : "dark-table-row"}`}
      onDoubleClick={() => setEdit(true)}
    >
      <Td width="10%" className="td-pos">
        {item.company_id}
      </Td>

      <Td width="10%" className="td-pos">
        {item.category_id}
      </Td>

      <Td width="20%" className={hasParentPos ? "td-pos" : "td-pos td-pos-last"}>
        {item.category_name}
      </Td>

      {hasParentPos && (
        <Td width="8%" className="td-pos td-pos-last">
          {item.parentid}
        </Td>
      )}

      <Td
        width="10%"
        className="td-acc td-acc-first"
        style={{ position: "relative" }}
      >
        {!edit ? (
          inputBox1
        ) : (
          <div
            data-account-dropdown-owner={accountDropdownOwnerRef.current}
            style={{ position: "relative", display: "flex", alignItems: "center" }}
          >
            <Input
              className="input-wrapper-row-inputbox"
              type="text"
              size="small"
              value={inputBox1}
              onChange={(e) => {
                setInputBox1(e.target.value);
                setChanged(true);
              }}
              onKeyDown={(e) => e.key === "Enter" && handleUpdate()}
            />
            <span
              style={{ marginLeft: 4, cursor: "pointer", fontSize: 16, userSelect: "none" }}
              onClick={() => {
                setShowDropdownAcc((prev) => !prev);
                setSearchTextAcc("");
              }}
            >
              ⏷
            </span>

            {showDropdownAcc && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  background: "#fff",
                  zIndex: 1000,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  border: "1px solid #ccc",
                  borderRadius: 4,
                  width: 450,
                  minWidth: "100%",
                  maxHeight: 200,
                  overflowY: "auto",
                  marginTop: 4,
                }}
              >
                <div style={{ padding: 4 }}>
                  <input
                    ref={accSearchRef}
                    type="text"
                    placeholder="Search..."
                    value={searchTextAcc}
                    onChange={(e) => setSearchTextAcc(e.target.value)}
                    style={{
                      width: "100%",
                      padding: 6,
                      fontSize: 14,
                      border: "1px solid #ccc",
                      borderRadius: 4,
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        const first = filteredAccountsAcc[0];
                        if (first) {
                          setInputBox1(first.id);
                          setInputBox2(first.description);
                          setChanged(true);
                          setShowDropdownAcc(false);
                          setSearchTextAcc("");
                        }
                      }
                    }}
                  />
                </div>

                {filteredAccountsAcc.map((acc) => (
                  <div
                    key={acc.id}
                    style={{
                      padding: "6px 8px",
                      cursor: "pointer",
                      borderBottom: "1px solid #eee",
                    }}
                    onClick={() => {
                      setInputBox1(acc.id);
                      setInputBox2(acc.description);
                      setChanged(true);
                      setShowDropdownAcc(false);
                      setSearchTextAcc("");
                    }}
                  >
                    <strong>{acc.id}</strong> — {acc.description}
                  </div>
                ))}

                {filteredAccountsAcc.length === 0 && (
                  <div style={{ padding: "6px 8px", color: "#999" }}>No results</div>
                )}
              </div>
            )}
          </div>
        )}
      </Td>

      <Td width="16%" className="td-acc">
        {!edit ? (
          inputBox2
        ) : (
          <Input
            className="input-wrapper-row-inputbox"
            type="text"
            size="small"
            value={inputBox2}
            onChange={(e) => {
              setInputBox2(e.target.value);
              setChanged(true);
            }}
            onKeyDown={(e) => e.key === "Enter" && handleUpdate()}
          />
        )}
      </Td>

      <Td width="10%" className="td-acc" style={{ position: "relative", display: hideClassDepartmentColumn ? "none" : undefined }}>
        {!edit ? (
          <>
            {inputBox8}
            {renderD365SettingsButton("main")}
          </>
        ) : (
          <QuickBooksClassDepartmentField
            value={inputBox8}
            onChange={(value) => {
              setInputBox8(value);
              setChanged(true);
            }}
            classDepartments={classList}
            onEnter={handleUpdate}
          >
            {renderD365SettingsButton("main")}
          </QuickBooksClassDepartmentField>
        )}
      </Td>

      <Td width="10%" className="td-acc" style={{ position: "relative" }}>
        {!edit ? (
          inputBox9
        ) : (
          <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
            <Input
              className="input-wrapper-row-inputbox"
              type="text"
              size="small"
              value={inputBox9}
              onChange={(e) => {
                setInputBox9(e.target.value);
                setChanged(true);
              }}
              onKeyDown={(e) => e.key === "Enter" && handleUpdate()}
            />
            <span
              style={{ marginLeft: 4, cursor: "pointer", fontSize: 16, userSelect: "none" }}
              onClick={() => {
                setShowCustomerDropdown((prev) => !prev);
                setCustomerSearchText("");
              }}
            >
              ⏷
            </span>

            {showCustomerDropdown && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  background: "#fff",
                  zIndex: 1000,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  border: "1px solid #ccc",
                  borderRadius: 4,
                  width: 450,
                  minWidth: "100%",
                  maxHeight: 200,
                  overflowY: "auto",
                  marginTop: 4,
                }}
              >
                <div style={{ padding: 4 }}>
                  <input
                    ref={customerSearchRef}
                    type="text"
                    placeholder="Search..."
                    value={customerSearchText}
                    onChange={(e) => setCustomerSearchText(e.target.value)}
                    style={{
                      width: "100%",
                      padding: 6,
                      fontSize: 14,
                      border: "1px solid #ccc",
                      borderRadius: 4,
                    }}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        const first = filteredCustomers[0];
                        if (first) {
                          setInputBox9(String(first.id));
                          setCustomerId(String(first.id));
                          setChanged(true);
                          setShowCustomerDropdown(false);
                          setCustomerSearchText("");
                        }
                      }
                    }}
                  />
                </div>

                {filteredCustomers.map((c) => (
                  <div
                    key={c.id}
                    style={{
                      padding: "6px 8px",
                      cursor: "pointer",
                      borderBottom: "1px solid #eee",
                    }}
                    onClick={() => {
                      setInputBox9(String(c.id));
                      setCustomerId(String(c.id));
                      setChanged(true);
                      setShowCustomerDropdown(false);
                      setCustomerSearchText("");
                    }}
                  >
                    <strong>{c.id}</strong> — {c.description}
                  </div>
                ))}

                {filteredCustomers.length === 0 && (
                  <div style={{ padding: "6px 8px", color: "#999" }}>No results</div>
                )}
              </div>
            )}
          </div>
        )}
      </Td>

      {showHiddenFields && (
        <>
          {renderDiscountCells()}
          <Td width="6%" className="td-acc">
            <Switch
              checked={checkBox3}
              onChange={() => {
                setEdit(true);
                setCheckBox3((prev) => !prev);
                setChanged(true);
              }}
            />
          </Td>

          <Td width="10%" className="td-acc" style={{ position: "relative" }}>
            {!edit ? (
              inputBox4
            ) : (
              <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                <Input
                  size="small"
                  value={inputBox4}
                  onChange={(e) => {
                    setInputBox4(e.target.value);
                    setChanged(true);
                  }}
                  onKeyDown={(e) => e.key === "Enter" && handleUpdate()}
                />
                <span
                  style={{ marginLeft: 4, cursor: "pointer", fontSize: 16, userSelect: "none" }}
                  onClick={() => {
                    setShowDropdownCogs((prev) => !prev);
                    setSearchTextCogs("");
                  }}
                >
                  ⏷
                </span>

                {showDropdownCogs && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      background: "#fff",
                      zIndex: 1000,
                      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                      border: "1px solid #ccc",
                      borderRadius: 4,
                      width: 450,
                      minWidth: "100%",
                      maxHeight: 200,
                      overflowY: "auto",
                      marginTop: 4,
                    }}
                  >
                    <div style={{ padding: 4 }}>
                      <input
                        ref={cogsSearchRef}
                        type="text"
                        placeholder="Search..."
                        value={searchTextCogs}
                        onChange={(e) => setSearchTextCogs(e.target.value)}
                        style={{
                          width: "100%",
                          padding: 6,
                          fontSize: 14,
                          border: "1px solid #ccc",
                          borderRadius: 4,
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            const first = filteredAccountsCogs[0];
                            if (first) {
                              setInputBox4(first.id);
                              setInputBox5(first.description);
                              setChanged(true);
                              setShowDropdownCogs(false);
                              setSearchTextCogs("");
                            }
                          }
                        }}
                      />
                    </div>

                    {filteredAccountsCogs.map((acc) => (
                      <div
                        key={`cogs-${acc.id}`}
                        style={{
                          padding: "6px 8px",
                          cursor: "pointer",
                          borderBottom: "1px solid #eee",
                        }}
                        onClick={() => {
                          setInputBox4(acc.id);
                          setInputBox5(acc.description);
                          setChanged(true);
                          setShowDropdownCogs(false);
                          setSearchTextCogs("");
                        }}
                      >
                        <strong>{acc.id}</strong> — {acc.description}
                      </div>
                    ))}

                    {filteredAccountsCogs.length === 0 && (
                      <div style={{ padding: "6px 8px", color: "#999" }}>No results</div>
                    )}
                  </div>
                )}
              </div>
            )}
          </Td>

          <Td width="12%" className="td-acc">
            {!edit ? (
              inputBox5
            ) : (
              <Input
                size="small"
                value={inputBox5}
                onChange={(e) => {
                  setInputBox5(e.target.value);
                  setChanged(true);
                }}
                onKeyDown={(e) => e.key === "Enter" && handleUpdate()}
              />
            )}
          </Td>

          <Td width="10%" className="td-acc" style={{ position: "relative" }}>
            {!edit ? (
              inputBox6
            ) : (
              <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
                <Input
                  size="small"
                  value={inputBox6}
                  onChange={(e) => {
                    setInputBox6(e.target.value);
                    setChanged(true);
                  }}
                  onKeyDown={(e) => e.key === "Enter" && handleUpdate()}
                />
                <span
                  style={{ marginLeft: 4, cursor: "pointer", fontSize: 16, userSelect: "none" }}
                  onClick={() => {
                    setShowDropdownCogsTotal((prev) => !prev);
                    setSearchTextCogsTotal("");
                  }}
                >
                  ⏷
                </span>

                {showDropdownCogsTotal && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      background: "#fff",
                      zIndex: 1000,
                      boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                      border: "1px solid #ccc",
                      borderRadius: 4,
                      width: 450,
                      minWidth: "100%",
                      maxHeight: 200,
                      overflowY: "auto",
                      marginTop: 4,
                    }}
                  >
                    <div style={{ padding: 4 }}>
                      <input
                        ref={cogsTotalSearchRef}
                        type="text"
                        placeholder="Search..."
                        value={searchTextCogsTotal}
                        onChange={(e) => setSearchTextCogsTotal(e.target.value)}
                        style={{
                          width: "100%",
                          padding: 6,
                          fontSize: 14,
                          border: "1px solid #ccc",
                          borderRadius: 4,
                        }}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            const first = filteredAccountsCogsTotal[0];
                            if (first) {
                              setInputBox6(first.id);
                              setInputBox7(first.description);
                              setChanged(true);
                              setShowDropdownCogsTotal(false);
                              setSearchTextCogsTotal("");
                            }
                          }
                        }}
                      />
                    </div>

                    {filteredAccountsCogsTotal.map((acc) => (
                      <div
                        key={`cogsTotal-${acc.id}`}
                        style={{
                          padding: "6px 8px",
                          cursor: "pointer",
                          borderBottom: "1px solid #eee",
                        }}
                        onClick={() => {
                          setInputBox6(acc.id);
                          setInputBox7(acc.description);
                          setChanged(true);
                          setShowDropdownCogsTotal(false);
                          setSearchTextCogsTotal("");
                        }}
                      >
                        <strong>{acc.id}</strong> — {acc.description}
                      </div>
                    ))}

                    {filteredAccountsCogsTotal.length === 0 && (
                      <div style={{ padding: "6px 8px", color: "#999" }}>No results</div>
                    )}
                  </div>
                )}
              </div>
            )}
          </Td>

          <Td width="12%" className="td-acc">
            {!edit ? (
              inputBox7
            ) : (
              <Input
                size="small"
                value={inputBox7}
                onChange={(e) => {
                  setInputBox7(e.target.value);
                  setChanged(true);
                }}
                onKeyDown={(e) => e.key === "Enter" && handleUpdate()}
              />
            )}
          </Td>
        </>
      )}

      <Td width="8%" textAlign="right" className="td-acc">
        {!edit ? (
          <Button size="small" fill="true" onClick={() => setEdit(true)}>
            Edit
          </Button>
        ) : (
          <Button size="small" fill="true" onClick={handleUpdate} disabled={!changed}>
            Update
          </Button>
        )}
      </Td>
    </Tr>
    </>
  );
};

export default Row;
